import { auth } from '@/lib/firebase'
import api from '@/lib/api';

const GET_OWN_COMPANY_VALIDATION = 'GET_OWN_COMPANY_VALIDATION';
const GET_ALL_COMPANIES_VALIDATIONS_COUNT = 'GET_ALL_COMPANIES_VALIDATIONS_COUNT';
const GET_UNSUBSCRIBERS = 'GET_UNSUBSCRIBERS';

const SET_OWN_COMPANY_VALIDATION = 'SET_OWN_COMPANY_VALIDATION';
const SET_ALL_COMPANIES_VALIDATIONS_COUNT = 'SET_ALL_COMPANIES_VALIDATIONS_COUNT';
const SET_UNSUBSCRIBERS = 'SET_UNSUBSCRIBERS';

const RESET = 'RESET';

const getDefaultState = () => ({
  ownCompanyValidation: null,
  allCompaniesValidations: {},
  allCompaniesValidationsCount: 0,
  unsubscribers: [],
});

const getters = {
  [GET_OWN_COMPANY_VALIDATION]: (state) => state.ownCompanyValidation,
  [GET_ALL_COMPANIES_VALIDATIONS_COUNT]: (state) => state.allCompaniesValidationsCount,
  [GET_UNSUBSCRIBERS]: (state) => state.unsubscribers,
};

const mutations = {
  [SET_OWN_COMPANY_VALIDATION](state, validation) {
    state.ownCompanyValidation = validation;
  },

  [SET_ALL_COMPANIES_VALIDATIONS_COUNT](state, count) {
    state.allCompaniesValidationsCount = count;
  },

  [SET_UNSUBSCRIBERS](state, unsubscribers) {
    state.unsubscribers = unsubscribers;
  },

  [RESET](state) {
    Object.assign(state, getDefaultState());
  },
};

export const actions = {
  async fetchValidations(_, { first, last, limit, search, type }) {
    const token = await auth.currentUser.getIdToken();

    try {
      const response = await api.get(
        '/admin/companies/validations',
        {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            first,
            last,
            limit,
            search,
            type,
          },
        },
      );

      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async updateValidation(_, { id, step, reason, isValid }) {
    const token = await auth.currentUser.getIdToken();

    try {
      const response = await api.put(
        `/admin/companies/validation/${id}`,
        {
          step,
          reason,
          isValid,
        },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async validateCompany(_, { id }) {
    const token = await auth.currentUser.getIdToken();

    try {
      const response = await api.post(
        `/admin/companies/validation/${id}/validate`,
        {
        },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async downloadFile(_, { id, filename }) {
    const token = await auth.currentUser.getIdToken();

    try {
      const response = await api.get(
        `/admin/companies/validation/${id}/file`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: { 
            filename,
          },
          responseType: 'blob',
        },
      );

      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};

export default {
  namespaced: true,
  state: getDefaultState(),
  getters,
  mutations,
  actions,
}; 